module.exports = __webpack_public_path__ + "img/round_af.2cb64e83.svg";